import type { GoogleOneTapLoginProps } from './type';
import type { CodeResponse } from '@/integrations/google-identity';
import { I18nConsumer } from '@wegic/i18n-core';
import { useGoogleAuth } from '@/hooks/useGoogleAuth';
import { useGoogleOneTapLogin } from '@/integrations/google-identity';
import { LOGIN_I18N_NAMESPACE, loginI18nLoaders } from '../../i18n/loaders';

/**
 * Google One Tap 登录组件
 */
function GoogleOneTapLoginContent(props: GoogleOneTapLoginProps) {
  const { config, isLogin = false } = props;
  const { api, onEvent } = config || {};

  const { handleGoogleLogin } = useGoogleAuth({
    apiConfig: api,
    getAnonymousId: config?.getAnonymousId,
    onEvent,
  });

  useGoogleOneTapLogin({
    client_id: api?.googleClientId,
    disabled: isLogin,
    onSuccess: (tokenResponse) => {
      handleGoogleLogin({ code: tokenResponse.credential } as CodeResponse);
    },
    onError: () => {
      console.error('Google One Tap Login Failed');
    },
  });

  return null;
}

export function GoogleOneTapLogin(props: GoogleOneTapLoginProps) {
  return (
    <I18nConsumer loaders={loginI18nLoaders} namespace={LOGIN_I18N_NAMESPACE}>
      <GoogleOneTapLoginContent {...props} />
    </I18nConsumer>
  );
}
